import {
	Button,
	Drawer,
	DrawerBody,
	DrawerCloseButton,
	DrawerContent,
	DrawerFooter,
	DrawerHeader,
	DrawerOverlay,
} from "@chakra-ui/react"
import { Form } from "formik"
import { ComponentProps, FC } from "react"

interface Props extends ComponentProps<typeof Drawer> {
	isSubmitting?: boolean
	isDisabled?: boolean
	headerLabel?: string
	submitLabel?: string
}

export const DrawerForm: FC<Props> = ({
	children,
	headerLabel,
	submitLabel,
	isSubmitting,
	isDisabled,
	...rest
}) => (
	<Drawer {...rest}>
		<DrawerOverlay />
		<Form>
			<DrawerContent>
				<DrawerCloseButton />
				<DrawerHeader borderBottomWidth="1px" fontWeight={"bold"} py={"2"}>
					{headerLabel ?? "Drawer Header"}
				</DrawerHeader>
				<DrawerBody>{children}</DrawerBody>

				<DrawerFooter borderTopWidth="1px" py={"2"}>
					<Button variant="outline" mr={3} onClick={rest.onClose}>
						Cancel
					</Button>
					<Button
						type="submit"
						colorScheme="blue"
						disabled={isSubmitting || isDisabled}
						isLoading={isSubmitting}
					>
						{submitLabel ?? "Submit"}
					</Button>
				</DrawerFooter>
			</DrawerContent>
		</Form>
	</Drawer>
)
